import { Loader } from '@googlemaps/js-api-loader';
import Utils from './framework/utils.js';
import WFGlobals from '../../core/scripts/globals.js';
import MapFilterModel from './map/filter-model.js';
import MapFilterView from './map/filter-view.js';

// MapBlock
// ========
//
// Represents a single Map listing locations provided via `window.{block_id}.map.locations`

class MapBlock extends EventTarget {
  constructor(dom) {
    super();
    this.dom = dom;

    Utils.bindMethods(this, [
      'onGMapsLoad', 'onFlyoutCloseClick', 'onWindowResize', 'onFlyoutTransitionEnd',
      'onFilterModelChange', 'onFilterChange', 'onFilterSubmit', 'onFilterReset'
    ]);

    this.loader = new Loader({
      apiKey: window.gmapi,
      version: 'weekly',
      libraries: ['geometry']
    })
    this.loader.load().then(this.onGMapsLoad)

    this.markers = [];

    this.filterModel = new MapFilterModel({
      options: {
        all: window[this.dom.getAttribute('id')].map.filters
      }
    });
    this.filterModel.addEventListener('Model.Change', this.onFilterModelChange);
    this.filterView = new MapFilterView(this.dom.querySelector('.map_filter-form'), this.filterModel);
    this.filterView.addEventListener(MapFilterView.Events.CHANGE, this.onFilterChange);
    this.filterView.addEventListener(MapFilterView.Events.SUBMIT, this.onFilterSubmit);
    this.filterView.addEventListener(MapFilterView.Events.RESET, this.onFilterReset);

    this.dom.querySelector('.map_flyout .close').addEventListener('click', this.onFlyoutCloseClick);
    this.dom.querySelector('.map_flyout').addEventListener('transitionend', this.onFlyoutTransitionEnd);
    window.addEventListener('resize', this.onWindowResize);
  }

  onGMapsLoad() {
    let mapDiv = this.dom.querySelector('.map_map');
    let zoom = parseInt(mapDiv.getAttribute('data-zoom'))
    this.map = new google.maps.Map(mapDiv, {
      center: { lat: parseFloat(mapDiv.getAttribute('data-lat')), lng: parseFloat(mapDiv.getAttribute('data-lng')) },
      zoom: Math.max(0, zoom - (window.innerWidth <  WFGlobals.breakpoints.sm ? 2 : (window.innerWidth < WFGlobals.breakpoints.md ? 1 : 0)))
    });
    window[this.dom.getAttribute('id')].map.locations.forEach((loc) => {
      let marker = new google.maps.Marker({
        position: {
          lat: parseFloat(loc.latitude),
          lng: parseFloat(loc.longitude)
        },
        map: this.map,
        title: loc.types ? loc.types.map((a) => a.label).join(', ') : null,
        icon: {
          url: window.theme_path + '/frontend/dist/images/icons/location-icon.png',
          size: new google.maps.Size(34, 49),
          origin: new google.maps.Point(0,0),
          anchor: new google.maps.Point(17, 49),
          labelOrigin: new google.maps.Point(17, 17)
        }
      });
      marker.data = loc;
      marker.addListener('click', this.onMarkerClick(marker))
      this.markers.push(marker);
    })
  }

  onMarkerClick(marker) {
    return (evt) => {
      this.map.panTo(marker.position);
      let address = [marker.data.city, marker.data.region, marker.data.country.toUpperCase()].filter((a) => a).join(', ');
      let description = [marker.data.divisions && marker.data.divisions.map((a) => a.label).join(', '), marker.data.types && marker.data.types.map((a) => a.label).join(', '), address].filter((a) => a).map((a) => `<p>${a}</p>`).join('')
      this.dom.querySelector('.map_flyout_location-description').innerHTML = description;
      this.dom.querySelector('.map_flyout').classList.remove('d-none');
      // RAF is needed to actually show the slide transition; without the delay, the rendering engine sees the display change
      // and the position change simultaneously, and does not animate
      window.requestAnimationFrame(() => {
        this.dom.querySelector('.map_flyout').classList.add('show');
      }, 1);
      this.dom.querySelector('.map').style.paddingBottom = this.dom.querySelector('.map_flyout').getBoundingClientRect().height + 'px';
    }
  }

  onFlyoutCloseClick(evt) {
    this.dom.querySelector('.map_flyout').classList.remove('show');
    this.dom.querySelector('.map').style.paddingBottom = 0;
  }

  onFlyoutTransitionEnd(evt) {
    if (!evt.currentTarget.classList.contains('show')) {
      this.dom.querySelector('.map_flyout_location-description').innerHTML = '';
      evt.currentTarget.classList.add('d-none');
    }
  }

  onWindowResize(evt) {
    if (this.dom.querySelector('.map_flyout.show'))
      this.dom.style.paddingBottom = this.dom.querySelector('.map_flyout').getBoundingClientRect().height + 'px';
  }

  onFilterSubmit(evt) {
    this.filterModel.set('currentFilter', this.filterModel.get('selectedFilter'));
  }

  onFilterReset(evt) {
    this.filterModel.reset();
  }

  onFilterChange(evt) {
    this.filterModel.selectFilter(evt.data, this.markers);
  }

  onFilterModelChange(evt) {
    if (evt.data.path == 'currentFilter') {
      this.markers.forEach((marker) => {
        marker.setMap(this.filterModel.checkItem(marker) ? this.map : null);
      })
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.wf-block-map').forEach((elem) => {
    let map = new MapBlock(elem);
  })
})